import apiClient from './apiClient';

export const login = async (credentials) => {
    try {
        const response = await apiClient.post('/auth/login', credentials);
        return {
            status: 'success',
            data: {
                user: response.data.data,
                token: response.data.data.token
            }
        };
    } catch (error) {
        return {
            status: 'error',
            error: {
                code: error.response?.status || 500,
                message: error.response?.status === 401
                    ? "Invalid credentials"
                    : "An error occurred during login"
            }
        };
    }
};

export const logout = async () => {
    try {
        await apiClient.post('/auth/logout');
        return {
            status: 'success',
            data: {
                message: "Logged out successfully"
            }
        };
    } catch (error) {
        // Even if logout fails, we should clear local state
        return {
            status: 'success',
            data: {
                message: "Logged out successfully"
            }
        };
    }
};

export const getProfile = async () => {
    try {
        const response = await apiClient.get('/auth/me');
        return {
            status: 'success',
            data: {
                user: response.data.data
            }
        };
    } catch (error) {
        return {
            status: 'error',
            error: {
                code: error.response?.status || 500,
                message: error.response?.status === 401
                    ? "Session expired"
                    : "Failed to fetch user profile"
            }
        };
    }
};

export const refreshToken = async () => {
    try {
        const response = await apiClient.post('/auth/refresh');
        return {
            status: 'success',
            data: {
                token: response.data.data.token,
                user: response.data.data
            }
        };
    } catch (error) {
        return {
            status: 'error',
            error: {
                code: error.response?.status || 500,
                message: error.response?.status === 401
                    ? "Session expired"
                    : "Failed to refresh session"
            }
        };
    }
};
